import { Component, OnInit } from '@angular/core';
import { SearchPackage } from '../models/searchPackage';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PhonePipe } from '../../pipes/phone.pipe';
import { AuthService } from '../../services/auth.service';
import { ClientService } from '../../clients-module/services/client.service';
import { SearchPackageService } from '../../services/search-package.service';
import { SimpleCreditRepo } from '../../models/ApplicantDataResponses/credit';

@Component({
  selector: 'app-packages-view',
  templateUrl: './packages-view.component.html',
  styleUrls: ['./packages-view.component.css']
})
export class PackagesViewComponent implements OnInit {

  packageToView : SearchPackage;
  creditRepositories : SimpleCreditRepo[] = [
    { name : 'Equifax', id : 0},
    { name : 'Experian', id : 1},
    { name : 'Transunion', id : 2},
  ];
  constructor(public datePipe: DatePipe, 
    public auth : AuthService, 
    public clients : ClientService, 
    public activatedRoute: ActivatedRoute, 
    public toast : ToastrService, 
    public phonePipe : PhonePipe,
    private location : Router,
    public searches : SearchPackageService) 
  {
    
  }

  ngOnInit() {
    this.setPackage();
  }

  GetCreditRepositoryName(repo : number)
  {
    try {
      return this.creditRepositories.find(r =>{return r.id == repo}).name;
    } catch (error) {
      
    }
  }

  setPackage() : void {
    this.activatedRoute.paramMap.subscribe((p : ParamMap) => {
      let id = p.get('pkg');
      this.searches.FetchSearchPackageById(id).subscribe((pkg: Array<SearchPackage>)=>{
        this.packageToView = Object.assign(new SearchPackage(),pkg[0]);
      })
    })
  }

  editPackage() : void {
    this.location.navigateByUrl(`packages/edit/${this.packageToView.id}`);
  }

}
